import pci from '../../assets/images/footer/pci.webp';
import master from '../../assets/images/footer/mastercard.webp';
import visa from '../../assets/images/footer/visa.webp';
import unicredit from '../../assets/images/footer/unibulbank.webp';
import secure from '../../assets/images/footer/secure.webp';
// import insta from '../../assets/images/footer/insta.webp';
// import linkin from '../../assets/images/footer/in.webp';
// import tube from '../../assets/images/footer/tube.webp';
// import fb from '../../assets/images/footer/fb.webp';
// import tiktok from '../../assets/images/footer/tiktok.webp';
import magnati from '../../assets/images/footer/magnati.webp';
import { BritainFlag, BulgariaFlag, RomaniaFlag, SaudiArabiaFlag, UaeFlag } from '../icons/icons';
import tube_blog from '../../assets/images/blog/tube.webp'
import tiktok_blog from '../../assets/images/blog/tiktok.webp'
import insta_blog from '../../assets/images/blog/inst.webp'
import fb_blog from '../../assets/images/blog/fb.webp'
import linkin_blog from '../../assets/images/blog/linkin.webp'
import { getRandomId } from './utils';

const importAll = (requireContext) =>
    requireContext
        .keys()
        .sort((a, b) => {
            const numA = parseInt(a.match(/item(\d+)/)[1], 10); // Use [1] to get the correct match
            const numB = parseInt(b.match(/item(\d+)/)[1], 10);
            return numA - numB;
        })
        .map((key) => requireContext(key)); // Ensure correct image import
const flags = importAll(require.context('../../assets/images/flags', false, /item\d+\.svg$/));

export const MAIN_URL = 'https://bg-sellavi-strapi.cabahub.com/api';
export const SELLAVI_API_URL = 'https://bg.sellavi.com'
export const SELLAVI_PBL_API_URL = 'https://pbg.sellavi.com'
export const PHOTO_URL = 'https://bg-sellavi-strapi.cabahub.com/uploads';

export const HEADING_BLOCK = 'heading';
export const PARAGRAPH_BLOCK = 'paragraph';
export const LIST_BLOCK = 'list';
export const ORDERED_LIST_FORMAT = 'ordered';
export const IMAGE_BLOCK = 'image';
export const QUOTE_BLOCK = 'quote';
export const CODE_BLOCK = 'code';
export const CHILD_TYPE_TEXT = 'text';
export const CHILD_TYPE_LINK = 'link';
export const CHILD_TYPE_LIST_ITEM = 'list-item';
export const TITLE_VAR = '{{TITLE}}';
export const GOOD_TITLE_VAR = '{{GOOD}}';
export const BAD_TITLE_VAR = '{{BAD}}';
export const PROMO_START_VAR = '{{PROMO_START}}';

export const CHAT_ID = '-1002229724615';
export const CHAT_ID_PARTNERS = '-1002226588458';
export const BOT_TOKEN = '6671687003:AAG-keX0Lch_FC_lduj4fzC6JBcyEOgL0KU';

export const CARDS_LIMIT = 9
export const productIdStorageKey = 'like'

export const EN_LANGUAGE = "EN";
export const BG_LANGUAGE = 'BG'
export const LANGUAGES = {
    EN: {
        lang: "En",
        flag: BritainFlag("flag-icon"),
    },
    BG: {
        lang: "Bg",
        flag: BulgariaFlag("flag-icon"),
    },
};
export const VALIDE_LANG = ['EN', 'BG']
// export const FOOTER_LINKS = [
//     {
//         title: 'Price',
//         link: '/price'
//     },
//     {
//         title: 'Partners',
//         link: '/partners'
//     },
//     {
//         title: 'How to thrive in e-commerce',
//         link: '/blog'
//     },
// ]

export const ONLINE_STORE = 'Online store'
export const SMM = 'SMM'
export const STARTING_UP = 'Starting up'
export const E_COMMERCE = 'E-commerce'
export const TECH = 'Tech'
export const MARKETING_AND_SALES = 'Marketing & Sales'

export const SOCIAL_BLOG = [
    {
        link: 'https://youtube.com/@sellavi.bulgaria?si=S_NG1OAeRTlOxo4L',
        img: tube_blog,
    },
    {
        link: 'https://www.instagram.com/sellavi.bulgaria/',
        img: insta_blog,
    },
    {
        link: 'https://www.tiktok.com/@sellavi.bulgaria?_t=8oeEK8HEtAu&_r=1',
        img: tiktok_blog,
    },
    {
        link: 'https://www.facebook.com/Sellavi.Bulgaria',
        img: fb_blog,
    },
    {
        link: 'https://www.linkedin.com/company/sellavi-bulgaria/',
        img: linkin_blog,
    },
]

export const FOOTER_LINKS_COLUMN = [
    {
        title: 'Get to know us',
        name: 'column1',
        subtitle: [
            {
                title: 'About Us',
                link: '/about'
            },
            {
                title: 'Terms & Conditions',
                link: ''
            },
            {
                title: 'Privacy Policy',
                link: ''
            },
            {
                title: 'Affiliates Program',
                link: ''
            },
        ],
        link: ''
    },
    {
        title: 'Abilities',
        name: 'column2',
        subtitle: [
            {
                title: 'Aquiring',
                link: ''
            },
            {
                title: 'Design & Branding',
                link: ''
            },
            {
                title: 'Booking & Digital Products',
                link: ''
            },
            {
                title: 'API & Webhook',
                link: ''
            },
            {
                title: 'Demo Version',
                link: ''
            },
        ],
        link: ''
    },
    {
        title: 'Sales & Marketing',
        name: 'column3',
        subtitle: [
            {
                title: 'Instagram Shopping',
                link: ''
            },
            {
                title: 'Facebook',
                link: ''
            },
            {
                title: 'TikTok for Business',
                link: ''
            },
            {
                title: 'Google SEO',
                link: ''
            }
        ],
        link: ''
    },
    {
        title: 'Support',
        name: 'column4line1',
        subtitle: [
            {
                title: 'Help Center',
                link: ''
            },
        ],
        link: ''
    },
    {
        title: 'Contact info',
        name: 'column4line2',
        subtitle: [
            {
                title: 'info@sellavi.com',
                link: ''
            },
            // {
            //     title: 'support@sellavi.com',
            //     link: ''
            // },
        ],
        link: ''
    },
    {
        title: '+359 2 4927 777',
        name: 'column4line3',
        link: ''
    },
]

// export const FOOTER_NAV_LINKS = [
//     {
//         path: '/about',
//         title: 'About us'
//     },
//     {
//         path: '/prices',
//         title: 'Prices'
//     },
//     {
//         path: '/partners',
//         title: 'Affiliate program'
//     },
//     {
//         path: '/blog',
//         title: 'How to thrive in e-commerce',
//         mobileTitle: 'How to do business',
//     },
//     // {
//     //     path: '#',
//     //     title: 'Free trial'
//     // },
// ]

export const FOOTER_CONTACTS = [
    {
        title: 'info@sellavi.com',
        link: 'mailto:info@sellavi.com'
    },
    // {
    //     title: 'support@sellavi.com',
    //     link: 'mailto:support@sellavi.com'
    // },
]

export const FOOTER_LOGO_COLOR = [
    {
        name: 'master',
        logo: master,
    },
    {
        name: 'visa',
        logo: visa
    },
    {
        name: 'magnati',
        logo: unicredit,
    },
    {
        name: 'secure',
        logo: secure
    },
    {
        name: 'pci',
        logo: pci
    },
]

export const FOOTER_LOGO_SOCIAL = [
    {
        logo: <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 3.25C5.89388 3.25 3.375 5.67558 3.375 8.66667V17.3333C3.375 20.3244 5.89388 22.75 9 22.75H18C21.1061 22.75 23.625 20.3244 23.625 17.3333V8.66667C23.625 5.67558 21.1061 3.25 18 3.25H9ZM20.25 5.41667C20.871 5.41667 21.375 5.902 21.375 6.5C21.375 7.098 20.871 7.58333 20.25 7.58333C19.629 7.58333 19.125 7.098 19.125 6.5C19.125 5.902 19.629 5.41667 20.25 5.41667ZM13.5 7.58333C16.6061 7.58333 19.125 10.0089 19.125 13C19.125 15.9911 16.6061 18.4167 13.5 18.4167C10.3939 18.4167 7.875 15.9911 7.875 13C7.875 10.0089 10.3939 7.58333 13.5 7.58333ZM13.5 9.75C12.6049 9.75 11.7464 10.0924 11.1135 10.7019C10.4806 11.3114 10.125 12.138 10.125 13C10.125 13.862 10.4806 14.6886 11.1135 15.2981C11.7464 15.9076 12.6049 16.25 13.5 16.25C14.3951 16.25 15.2536 15.9076 15.8865 15.2981C16.5194 14.6886 16.875 13.862 16.875 13C16.875 12.138 16.5194 11.3114 15.8865 10.7019C15.2536 10.0924 14.3951 9.75 13.5 9.75Z" fill="white" />
        </svg>,
        link: "https://www.instagram.com/sellavi.bulgaria"
    },
    {
        logo: <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.9851 9.75039H15.1663V7.58373C15.1663 6.46573 15.2573 5.76156 16.8596 5.76156H18.8833V2.31656C17.8985 2.21473 16.9083 2.16489 15.9171 2.16706C12.978 2.16706 10.833 3.96214 10.833 7.25764V9.75039H7.58301V14.0837L10.833 14.0826V23.8337H15.1663V14.0805L18.4878 14.0794L18.9851 9.75039Z" fill="white" />
        </svg>,
        link: 'https://www.facebook.com/sellavi.bulgaria'
    },
    {
        logo: <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.3201 2.08008H4.68008C3.24488 2.08008 2.08008 3.24488 2.08008 4.68008V21.3201C2.08008 22.7553 3.24488 23.9201 4.68008 23.9201H21.3201C22.7553 23.9201 23.9201 22.7553 23.9201 21.3201V4.68008C23.9201 3.24488 22.7553 2.08008 21.3201 2.08008ZM8.84008 10.4001V20.2801H5.72008V10.4001H8.84008ZM5.72008 7.52448C5.72008 6.79648 6.34408 6.24008 7.28008 6.24008C8.21608 6.24008 8.80368 6.79648 8.84008 7.52448C8.84008 8.25248 8.25768 8.84008 7.28008 8.84008C6.34408 8.84008 5.72008 8.25248 5.72008 7.52448ZM20.2801 20.2801H17.1601C17.1601 20.2801 17.1601 15.4649 17.1601 15.0801C17.1601 14.0401 16.6401 13.0001 15.3401 12.9793H15.2985C14.0401 12.9793 13.5201 14.0505 13.5201 15.0801C13.5201 15.5533 13.5201 20.2801 13.5201 20.2801H10.4001V10.4001H13.5201V11.7313C13.5201 11.7313 14.5237 10.4001 16.5413 10.4001C18.6057 10.4001 20.2801 11.8197 20.2801 14.6953V20.2801Z" fill="white" />
        </svg>,
        link: 'https://www.linkedin.com/company/sellavi-bulgaria/'
    },
    {
        logo: <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.9068 6.38819C20.8182 6.14256 19.8326 5.53656 19.0934 4.65854C18.3542 3.78052 17.9002 2.67638 17.7976 1.50708V1H14.0426V16.7207C14.0403 17.4167 13.8313 18.0944 13.4451 18.6587C13.0588 19.2229 12.5147 19.6452 11.8891 19.8664C11.2636 20.0875 10.5881 20.0964 9.95753 19.8916C9.32698 19.6869 8.7731 19.2789 8.3737 18.7249C7.9681 18.1617 7.74311 17.4768 7.73134 16.7696C7.71958 16.0624 7.92165 15.3696 8.30827 14.7918C8.69488 14.2139 9.24593 13.7809 9.88151 13.5557C10.5171 13.3305 11.2042 13.3246 11.8431 13.5391V9.51464C10.4183 9.30686 8.96764 9.57407 7.69394 10.2789C6.42024 10.9837 5.38723 12.0909 4.73939 13.4456C4.09156 14.8003 3.8613 16.3347 4.08084 17.8343C4.30037 19.3338 4.95871 20.7234 5.96378 21.8088C6.92225 22.8434 8.15122 23.5532 9.49381 23.8476C10.8364 24.1421 12.2317 24.0078 13.5016 23.4619C14.7715 22.916 15.8585 21.9833 16.6236 20.7828C17.3888 19.5823 17.7975 18.1685 17.7976 16.7219V8.68904C19.3151 9.83353 21.1346 10.4472 23 10.4437V6.50778C22.6326 6.50826 22.2662 6.46818 21.9068 6.38819Z" fill="white" />
        </svg>,
        link: 'https://www.tiktok.com/@sellavi.bulgaria'
    },
    {
        logo: <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.3468 7.53969C23.1396 6.39609 22.1524 5.56328 21.0068 5.30328C19.2924 4.93969 16.1196 4.67969 12.6868 4.67969C9.25598 4.67969 6.03238 4.93969 4.31598 5.30328C3.17238 5.56328 2.18316 6.34328 1.97598 7.53969C1.76676 8.83969 1.55957 10.6597 1.55957 12.9997C1.55957 15.3397 1.76676 17.1597 2.02676 18.4597C2.23598 19.6033 3.22316 20.4361 4.36676 20.6961C6.18676 21.0597 9.30676 21.3197 12.7396 21.3197C16.1724 21.3197 19.2924 21.0597 21.1124 20.6961C22.256 20.4361 23.2432 19.6561 23.4524 18.4597C23.6596 17.1597 23.9196 15.2869 23.9724 12.9997C23.8668 10.6597 23.6068 8.83969 23.3468 7.53969ZM9.87957 16.6397V9.35969L16.2232 12.9997L9.87957 16.6397Z" fill="white" />
        </svg>,
        link: 'https://www.youtube.com/@sellavi.bulgaria'
    },
]


export const INFO_EMAIL = 'support.bg@sellavi.com'

export const THEME_LIGHT_TYPE = 'light'
export const THEME_DARK_TYPE = 'dark'

export const HEADER_LINKS = [
    // {
    //     path: '/',
    //     name: 'Home'
    // },
    {
        path: '/about',
        name: 'About us'
    },
    {
        path: '/prices',
        name: 'Prices'
    },
    {
        path: '/partners',
        name: 'Affiliate program'
    },
    {
        path: '/blog',
        name: 'How to thrive in e-commerce'
    },
]

export const MAIN_NAV_LINKS = [
    {
        path: 'start',
        name: 'Start trial'
    },
    {
        path: 'reviews',
        name: 'Customer reviews'
    },
    {
        path: 'steps',
        name: 'Setup steps'
    },
    {
        path: 'features',
        name: 'Features'
    },
    {
        path: 'ai',
        name: 'AI commerce'
    },
    {
        path: 'examples',
        name: 'Examples'
    },
    {
        path: 'benefits',
        name: 'Benefits'
    },
]

export const UAE_PHONE_CODE = { icon: UaeFlag, value: '+971' };
export const SAUDI_PHONE_CODE = { icon: SaudiArabiaFlag, value: '+966' };
export const ROMANIA_PHONE_CODE = { icon: RomaniaFlag, value: '+40' };
export const BULGARIA_PHONE_CODE = { icon: BulgariaFlag, value: '+359' };

export const PHONE_CODES_LIST = [
    // UAE_PHONE_CODE,
    // // SAUDI_PHONE_CODE,
    // ROMANIA_PHONE_CODE,
    // BULGARIA_PHONE_CODE,
    // { icon: AlbaniaFlag, value: '+354' },
    { icon: flags[0], value: '+354' },
    { icon: flags[1], value: '+54' },
    { icon: flags[2], value: '+213' },
    { icon: flags[3], value: '+93' },
    { icon: flags[4], value: '+971' },
    { icon: flags[5], value: '+297' },
    { icon: flags[6], value: '+968' },
    { icon: flags[7], value: '+994' },
    { icon: flags[8], value: '+20' },
    { icon: flags[9], value: '+251' },
    { icon: flags[10], value: '+353' },
    { icon: flags[11], value: '+372' },
    { icon: flags[12], value: '+376' },
    { icon: flags[13], value: '+244' },
    { icon: flags[14], value: '+1264' },
    { icon: flags[15], value: '+61' },
    { icon: flags[16], value: '+43' },
    { icon: flags[17], value: '+1268' },
    { icon: flags[18], value: '+853' },
    { icon: flags[19], value: '+1246' },
    { icon: flags[20], value: '+1242' },
    { icon: flags[21], value: '+675' },
    { icon: flags[22], value: '+92' },
    { icon: flags[23], value: '+595' },
    { icon: flags[24], value: '+970' },
    { icon: flags[25], value: '+973' },
    { icon: flags[26], value: '+507' },
    { icon: flags[27], value: '+55' },
    { icon: flags[28], value: '+375' },
    { icon: flags[29], value: '+1441' },
    { icon: flags[30], value: '+359' },
    { icon: flags[31], value: '+1670' },
    { icon: flags[32], value: '+229' },
    { icon: flags[33], value: '+32' },
    { icon: flags[34], value: '+354' },
    { icon: flags[35], value: '+1' },
    { icon: flags[36], value: '+48' },
    { icon: flags[37], value: '+387' },
    { icon: flags[38], value: '+591' },
    { icon: flags[39], value: '+501' },
    { icon: flags[40], value: '+680' },
    { icon: flags[41], value: '+267' },
    { icon: flags[42], value: '+975' },
    { icon: flags[43], value: '+226' },
    { icon: flags[44], value: '+257' },
    { icon: flags[45], value: '+850' },
    { icon: flags[46], value: '+240' },
    { icon: flags[47], value: '+45' },
    { icon: flags[48], value: '+49' },
    { icon: flags[49], value: '+670' },
    { icon: flags[50], value: '+228' },
    { icon: flags[51], value: '+1767' },
    { icon: flags[52], value: '+1809' },
    { icon: flags[53], value: '+7' },
    { icon: flags[54], value: '+593' },
    { icon: flags[55], value: '+291' },
    { icon: flags[56], value: '+33' },
    { icon: flags[57], value: '+298' },
    { icon: flags[58], value: '+689' },
    { icon: flags[59], value: '+594' },
    { icon: flags[60], value: '+508' },
    { icon: flags[61], value: '+39' },
    { icon: flags[62], value: '+63' },
    { icon: flags[63], value: '+679' },
    { icon: flags[64], value: '+358' },
    { icon: flags[65], value: '+238' },
    { icon: flags[66], value: '+500' },
    { icon: flags[67], value: '+220' },
    { icon: flags[68], value: '+242' },
    { icon: flags[69], value: '+243' },
    { icon: flags[70], value: '+57' },
    { icon: flags[71], value: '+506' },
    { icon: flags[72], value: '+1473' },
    { icon: flags[73], value: '+299' },
    { icon: flags[74], value: '+995' },
    { icon: flags[75], value: '+590' },
    { icon: flags[76], value: '+1671' },
    { icon: flags[77], value: '+592' },
    { icon: flags[78], value: '+7' },
    { icon: flags[79], value: '+509' },
    { icon: flags[80], value: '+82' },
    { icon: flags[81], value: '+31' },
    { icon: flags[82], value: '+599' },
    { icon: flags[83], value: '+382' },
    { icon: flags[84], value: '+504' },
    { icon: flags[85], value: '+686' },
    { icon: flags[86], value: '+253' },
    { icon: flags[87], value: '+996' },
    { icon: flags[88], value: '+245' },
    { icon: flags[89], value: '+224' },
    { icon: flags[90], value: '+1' },
    { icon: flags[91], value: '+233' },
    { icon: flags[92], value: '+241' },
    { icon: flags[93], value: '+855' },
    { icon: flags[94], value: '+420' },
    { icon: flags[95], value: '+263' },
    { icon: flags[96], value: '+237' },
    { icon: flags[97], value: '+974' },
    { icon: flags[98], value: '+1345' },
    { icon: flags[99], value: '+269' },
    { icon: flags[100], value: '+381' },
    { icon: flags[101], value: '+225' },
    { icon: flags[102], value: '+965' },
    { icon: flags[103], value: '+385' },
    { icon: flags[104], value: '+254' },
    { icon: flags[105], value: '+682' },
    { icon: flags[106], value: '+599' },
    { icon: flags[107], value: '+371' },
    { icon: flags[108], value: '+266' },
    { icon: flags[109], value: '+856' },
    { icon: flags[110], value: '+961' },
    { icon: flags[111], value: '+370' },
    { icon: flags[112], value: '+231' },
    { icon: flags[113], value: '+218' },
    { icon: flags[114], value: '+423' },
    { icon: flags[115], value: '+262' },
    { icon: flags[116], value: '+352' },
    { icon: flags[117], value: '+250' },
    { icon: flags[118], value: '+40' },
    { icon: flags[119], value: '+261' },
    { icon: flags[120], value: '+44' },
    { icon: flags[121], value: '+960' },
    { icon: flags[122], value: '+356' },
    { icon: flags[123], value: '+265' },
    { icon: flags[124], value: '+60' },
    { icon: flags[125], value: '+223' },
    { icon: flags[126], value: '+389' },
    { icon: flags[127], value: '+692' },
    { icon: flags[128], value: '+596' },
    { icon: flags[129], value: '+262' },
    { icon: flags[130], value: '+230' },
    { icon: flags[131], value: '+222' },
    { icon: flags[132], value: '+1' },
    { icon: flags[133], value: '+1684' },
    { icon: flags[134], value: '+1340' },
    { icon: flags[135], value: '+976' },
    { icon: flags[136], value: '+1664' },
    { icon: flags[137], value: '+880' },
    { icon: flags[138], value: '+51' },
    { icon: flags[139], value: '+691' },
    { icon: flags[140], value: '+95' },
    { icon: flags[141], value: '+373' },
    { icon: flags[142], value: '+212' },
    { icon: flags[143], value: '+377' },
    { icon: flags[144], value: '+258' },
    { icon: flags[145], value: '+52' },
    { icon: flags[146], value: '+264' },
    { icon: flags[147], value: '+27' },
    { icon: flags[148], value: '+211' },
    { icon: flags[149], value: '+674' },
    { icon: flags[150], value: '+505' },
    { icon: flags[151], value: '+977' },
    { icon: flags[152], value: '+227' },
    { icon: flags[153], value: '+234' },
    { icon: flags[154], value: '+683' },
    { icon: flags[155], value: '+47' },
    { icon: flags[156], value: '+672' },
    { icon: flags[157], value: '+351' },
    { icon: flags[158], value: '+81' },
    { icon: flags[159], value: '+46' },
    { icon: flags[160], value: '+41' },
    { icon: flags[161], value: '+503' },
    { icon: flags[162], value: '+685' },
    { icon: flags[163], value: '+381' },
    { icon: flags[164], value: '+232' },
    { icon: flags[165], value: '+221' },
    { icon: flags[166], value: '+357' },
    { icon: flags[167], value: '+248' },
    { icon: flags[168], value: '+966' },
    { icon: flags[169], value: '+590' },
    { icon: flags[170], value: '+239' },
    { icon: flags[171], value: '+290' },
    { icon: flags[172], value: '+1869' },
    { icon: flags[173], value: '+1758' },
    { icon: flags[174], value: '+590' },
    { icon: flags[175], value: '+599' },
    { icon: flags[176], value: '+378' },
    { icon: flags[177], value: '+1784' },
    { icon: flags[178], value: '+94' },
    { icon: flags[179], value: '+421' },
    { icon: flags[180], value: '+386' },
    { icon: flags[181], value: '+268' },
    { icon: flags[182], value: '+249' },
    { icon: flags[183], value: '+597' },
    { icon: flags[184], value: '+677' },
    { icon: flags[185], value: '+252' },
    { icon: flags[186], value: '+992' },
    { icon: flags[187], value: '+886' },
    { icon: flags[188], value: '+66' },
    { icon: flags[189], value: '+255' },
    { icon: flags[190], value: '+676' },
    { icon: flags[191], value: '+1649' },
    { icon: flags[192], value: '+1868' },
    { icon: flags[193], value: '+216' },
    { icon: flags[194], value: '+688' },
    { icon: flags[195], value: '+90' },
    { icon: flags[196], value: '+993' },
    { icon: flags[197], value: '+690' },
    { icon: flags[198], value: '+681' },
    { icon: flags[199], value: '+678' },
    { icon: flags[200], value: '+502' },
    { icon: flags[201], value: '+58' },
    { icon: flags[202], value: '+673' },
    { icon: flags[203], value: '+256' },
    { icon: flags[204], value: '+380' },
    { icon: flags[205], value: '+598' },
    { icon: flags[206], value: '+998' },
    { icon: flags[207], value: '+30' },
    { icon: flags[208], value: '+34' },
    { icon: flags[209], value: '+212' },
    { icon: flags[210], value: '+856' },
    { icon: flags[211], value: '+65' },
    { icon: flags[212], value: '+687' },
    { icon: flags[213], value: '+64' },
    { icon: flags[214], value: '+36' },
    { icon: flags[215], value: '+963' },
    { icon: flags[216], value: '+1876' },
    { icon: flags[217], value: '+374' },
    { icon: flags[218], value: '+967' },
    { icon: flags[219], value: '+964' },
    { icon: flags[220], value: '+98' },
    { icon: flags[221], value: '+972' },
    { icon: flags[222], value: '+39' },
    { icon: flags[223], value: '+91' },
    { icon: flags[224], value: '+62' },
    { icon: flags[225], value: '+44' },
    { icon: flags[226], value: '+1284' },
    { icon: flags[227], value: '+246' },
    { icon: flags[228], value: '+962' },
    { icon: flags[229], value: '+84' },
    { icon: flags[230], value: '+260' },
    { icon: flags[231], value: '+44' },
    { icon: flags[232], value: '+235' },
    { icon: flags[233], value: '+350' },
    { icon: flags[234], value: '+56' },
    { icon: flags[235], value: '+236' },
    { icon: flags[236], value: '+86' },
].map((item)=>({
    ...item,
    _id: getRandomId()
}));

export const initialSignupValues = {
    code: PHONE_CODES_LIST[30],
    email: '',
    phone: '',
    password: '',
};


export const initialJoinValues = {
    name: '',
    email: '',
    phone: '',
    linkedin: '',
    position: '',
    why: '',
    comments: '',
    bank_name: '',
    bank_branch: '',
    bank_account: '',
    bank_holder_name: ''
};

export const initialSugnupValidity = {
    email: {},
    phone: {},
    password: {},
    name: {},
    business: {},
    occupation: {},
    confirm: {},
    linkedin: {},
    position: {},
    why: {},
    comments: {},
    bank_name: {},
    bank_branch: {},
    bank_account: {},
    bank_holder_name: {}
};

export const TERMS_OF_SERVICE_LINK = 'https://www.sellavi.com/region/bg/assets/pdf/agreement.pdf?2'
export const PRIVACY_POLICY_LINK = 'https://www.sellavi.com/region/bg/assets/pdf/politics.pdf?2'